import React, { useState } from 'react';
import { supabase } from '../../utils/supabaseClient';
import { safeResetPasswordForEmail } from '../../utils/supabaseAuthSafe';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsSubmitting(true);

    try {
      const redirectTo = `${window.location.origin}/auth/reset`;
      const { error: resetError } = await safeResetPasswordForEmail(supabase, {
        email,
        redirectTo,
        timeoutMs: 10000,
      });
      if (resetError) throw resetError;

      // Security best practice: don't reveal whether the email exists.
      setMessage(
        'If an account exists for that email, you’ll receive a password reset link shortly.'
      );
    } catch (err) {
      if (err?.code === 'TIMEOUT') {
        setError(
          'Request timed out. Please check your connection/VPN/adblock and try again.'
        );
      } else {
        setError(err?.message || 'Failed to request password reset');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Reset your password</h2>
        <p className="auth-subtitle">
          Enter your email and we’ll send you a reset link.
        </p>

        <form onSubmit={handleSubmit} className="auth-form">
          <label className="auth-field">
            Email
            <input
              className="auth-input"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>

          <button className="auth-button" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Please wait...' : 'Send reset link'}
          </button>
        </form>

        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-message">{message}</div>}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;

